import { render, staticRenderFns } from "./ModalCriarEditarItemAgendaGarantiaMinimaPeriodo.vue?vue&type=template&id=974d4c42&scoped=true"
import script from "./ModalCriarEditarItemAgendaGarantiaMinimaPeriodo.vue?vue&type=script&lang=ts"
export * from "./ModalCriarEditarItemAgendaGarantiaMinimaPeriodo.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarEditarItemAgendaGarantiaMinimaPeriodo.vue?vue&type=style&index=0&id=974d4c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974d4c42",
  null
  
)

export default component.exports